import React from 'react';
import styled from '@emotion/styled';
import { Scroller, } from '@argo/ui-elements';

const Container = styled.div`
  height: 100%;
  overflow: hidden;
`;

export const StyledScroller = styled(Scroller,)`
  height: 385px;
  padding-top: 5px;
`;

const PageContent = ({ children, }: any,) => (
  <Container>
    <StyledScroller vertical>
      {children}
    </StyledScroller>
  </Container>
);

export default PageContent;
